module.exports = __webpack_public_path__ + "fm.dc5fbf1dd5f40da5ea36.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/fm.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/fm.svg
// module chunks = styles